"use client"

import { useEffect } from "react"
import { useLocale, useMessages } from "next-intl"

import { setImperativeMessages } from "@/lib/i18n/imperative"
import { type Locale } from "@/i18n/config"

/**
 * Mirrors the active messages into module scope, for code that cannot hold a hook.
 *
 * Renders nothing. It exists to be inside `NextIntlClientProvider` — which is the only place the
 * messages can be read from — and to write them somewhere the toasts can reach. See
 * lib/i18n/imperative for why that is necessary and what it costs.
 *
 * In an effect rather than during render, because writing module state while rendering is a side
 * effect in the middle of a pure function and React is free to run that twice.
 */
export function ImperativeMessages() {
  const locale = useLocale()
  const messages = useMessages()

  useEffect(() => {
    setImperativeMessages(locale as Locale, messages as Record<string, unknown>)
  }, [locale, messages])

  return null
}
